import script from "./MobileAppOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileAppOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./MobileAppOnboarding.vue?vue&type=style&index=0&id=3c1082a6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1082a6"]])

export default __exports__